import React from 'react';
import {
  TableContainer as MuiTableContainer,
  Table as MuiTable,
  TableHead as MuiTableHead,
  TableBody as MuiTableBody,
  TableRow as MuiTableRow,
  TableCell as MuiTableCell
} from '@mui/material';

export const CustomTableContainer = React.forwardRef(({ sx, children, ...props }, ref) => (
  <MuiTableContainer
    ref={ref}
    sx={{ border: 'none', overflowX: 'auto', ...sx }}
    {...props}
  >
    {children}
  </MuiTableContainer>
));

export const CustomTable = ({ sx, children, ...props }) => (
  <MuiTable sx={sx} {...props}>
    {children}
  </MuiTable>
);

export const CustomTableHead = ({ sx, children, ...props }) => (
  <MuiTableHead sx={sx} {...props}>
    {children}
  </MuiTableHead>
);

export const CustomTableBody = ({ sx, children, ...props }) => (
  <MuiTableBody sx={sx} {...props}>
    {children}
  </MuiTableBody>
);

export const CustomTableRow = ({ sx, children, ...props }) => (
  <MuiTableRow sx={sx} {...props}>
    {children}
  </MuiTableRow>
);

export const CustomTableCell = ({ sx, children, ...props }) => (
  <MuiTableCell
    sx={{
      fontFamily: 'Poppins',
      ...sx
    }}
    {...props}
  >
    {children}
  </MuiTableCell>
);
